module.exports = __webpack_public_path__ + "img/caselist7.ef00f1fc.jpg";